<template>
  <div :class="$style.wallet">
    <header>
      <i :class="`iconfont yw-xiangzuo ${$style.back}`" @click="back"></i>
      <p>我的钱包</p>
    </header>
    <div :class="$style.redEnvelopeType" v-if="!withdrawStep">
      <div :class="$style.info">
        <div>
          <p :class="$style.account">用户账号: {{ user_name }}</p>
          <p>角色: {{ role.role_name }}</p>
        </div>
        <div>
          <p :class="$style.account">区服: {{ role.server_name }}</p>
          <p>总余额: {{ allBalance }}元</p>
        </div>
      </div>
      <ul :class="$style.typeList">
        <li v-for="(item, index) in wallet_list" :key="index">
          <div>
            <img :src="`${$cdnLink}/red-envelope/loginPack.png`" alt="" />
            <div>
              <p :class="$style.typeName">{{ handleWalletName(item) }}</p>
              <p :class="$style.typeBalance">
                未提现<span>{{ item.money }}</span
                >元
              </p>
            </div>
          </div>
          <button @click="selectWithdrawType(item)">立即提现</button>
        </li>
      </ul>
      <p :class="$style.record" @click="toRecord">
        <span>使用记录</span>
        <i :class="`iconfont yw-xiangyou `"></i>
      </p>
    </div>
    <div :class="$style.balanceWithdraw" v-if="withdrawStep == 2">
      <div :class="$style.price">
        <h3>
          <p>提现金额</p>
          <p @click="stepVisible=true" :class="$style.fr">提现攻略 ></p>
        </h3>
        <ul>
          <li 
            v-for="(item, index) in options" 
            :key="index" 
            @click="selectMoney(item)"
            :class="[activeJudge(item) ? $style.active : '', withDrawAccount === item ? $style.select : '']"
          >
          <span v-if="item.money_threshold ? Number(availWithdrawAmount) >= Number(item.value) && Number(availWithdrawAmount) >= Number(item.money_threshold) : Number(availWithdrawAmount) >= Number(item.value)" :class="$style.avail">可提现</span>
          <span>{{ item.label }}</span>
          <span :class="$style.amountHint" v-if="Number(availWithdrawAmount) < Number(item.value) && withDrawAccount === item">余额不足！</span>
          <span :class="$style.remain" v-else-if="item.money_threshold && Number(availWithdrawAmount) >= Number(item.value) && Number(availWithdrawAmount) < Number(item.money_threshold) && withDrawAccount === item">余额达到<span>{{item.money_threshold}}</span>元可提现</span>
            <span v-else-if="item.type == 2 && withDrawAccount === item" :class="$style.remain">剩余可提现次数：<span>{{ item.count }}</span>次</span>
          </li>
        </ul>
      </div>
      <div :class="$style.method" v-if="methodOptions.length">
        <h3>提现方式</h3>
        <ul :class="$style.options">
          <li
            v-for="(item, index) in methodOptions"
            :key="index"
            @click="selectMethods(item)"
            :class="item.value === currentMethod.value ? $style.active : ''"
          >
            <div>
              <img v-if="item.value == 2" :class="$style.recommend" :src="`${$cdnLink}/red-envelope/recommend.png`" />
              <img :src="item.icon" alt="" v-if="item.icon" />
            </div>
            <p>{{ item.label }}</p>
          </li>
        </ul>
        <p :class="$style.hint" v-if="currentMethod.value == 1">* 微信提现需要关注公众号且绑定游戏账号哦！</p>
      </div>
      <button :class="[$style.withdraw, $style.submit]" @click="withDraw">立即使用</button>
      <div :class="$style.statement">
        <p @click="statementVisible = true">免责声明 ></p>
      </div>
    </div>
    <!-- 提现认证 -->
    <AntiIndulged v-if="bindShow" @close="bindShow = false" @success="bindShow = false" :type="currentWithDrawType"></AntiIndulged>
    <Statement v-if="statementVisible" @close="statementVisible = false"></Statement>
    <div :class="$style.popup" v-if="withDrawSuccess">
      <div :class="$style.content">
        <i :class="[$style.fanhui, 'iconfont', 'yw-guanbi1']" @click="withDrawSuccess = false"></i>
        <p>您的提现申请已提交成功</p>
        <p>请前往{{ handleWithDrawType() }}查收，红包将会在48小时内{{ currentWithDrawType == 3 ? '以游戏道具形势下发' : '尽快发放' }}</p>
        <p :class="$style.sm">点击<span :class="$style.link" @click="stepVisible=true">提现攻略 ></span>，可查看详细领取步骤</p>
      </div>
    </div>
    <div :class="[$style.popup, $style.bindAccount]" v-if="bindVisible">
      <div :class="$style.content">
        <i :class="[$style.fanhui, 'iconfont', 'yw-guanbi1']" @click="bindVisible = false"></i>
        <p style="text-align: center">绑定说明</p>
        <p>1、复制下方绑定码</p>
        <p>2、点击“前往微信”，关注<span>星娱福利中心</span>微信公众号，选择“福利中心”-“红包提现”进行绑定</p>
        <p :class="$style.sm">注意：</p>
        <p :class="$style.sm">1、请勿将绑定码告知他人</p>
        <p :class="$style.sm">2、账号绑定微信号后无法更改，请确定绑定正确的微信号</p>
        <div :class="$style.bindContent">
          <span>绑定码：</span>
          <span :class="$style.code">{{ bindUserAuthCode }}</span>
          <button class="copy-btn" :data-clipboard-text="bindUserAuthCode">复制</button>
        </div>
        <button :class="$style.redirectWechat" @click="jump">前往微信</button>
      </div>
    </div>
    <Step v-if="stepVisible" @backWallet="stepVisible=false"></Step>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import {
  getWalletInfoV2,
  withDraw,
  withDrawV2,
  getWithdrawOptionsV3,
  getTempId,
  checkALiBindResult,
} from '@/api/activity';
import AntiIndulged from './AntiIndulged';
import Statement from './Statement';
import { gameOpenDownloads, backGameFromliPa } from '@/bridge/AppJsBridge';
import ClipboardJS from 'clipboard';
import Step from "./Step.vue";

// 充值方式
const RECHARGE_TYPE = {
  DIRECT: 3, // 直充
  WECHAT: 1, // 微信
  ALIPAY: 2, // 支付宝
};

export default {
  name: '',
  data() {
    return {
      balance: 0.0,
      flash_money: 0.0,
      options: [],
      flashOptions: [],
      methodOptions: [],
      withDrawAccount: null,
      withDrawFlag: false,
      hintShow: false,
      currentMethod: {},
      direct_recharge: '',
      direct_rate: '',
      bindShow: false, // 提现认证弹窗
      statementVisible: false,
      withDrawSuccess: false,
      withdrawType: '', // 提现类型 1.等级 2.充值 3.高级
      withdrawMethod: 0, // 提现方式 默认0 0.普通红包 1.闪电提现
      bindVisible: false, // 未绑定公众号弹框提示
      bindUserAuthCode: '', // 用户临时绑定码
      retryTime: 0,
      currentWithDrawType: '',
      withdrawStep: 0, // 提现步骤 0.选择红包类型 1.选择提现方式 2.选择提现金额
      allBalance: 0,
      availWithdrawAmount: 0,
      stepVisible: false,
      wallet_list: []
    };
  },
  async mounted() {
    this.getBalance();
    this.copyInit();
    backGameFromliPa(() => {
      this.checkALiBind();
    });
  },
  computed: {
    ...mapState({
      receive_info: (state) => state.redEnvelope.receive_info,
      appkey: (state) => state.user.appkey,
      user_id: (state) => state.user.user_id,
      user_name: (state) => state.user.username,
      tel_status: (state) => state.user.tel_status,
      role: (state) => state.redEnvelope.role,
    }),
  },
  methods: {
    copyInit() {
      this.copy = new ClipboardJS('.copy-btn');
      this.copy.on('success', (e) => {
        this.$toast('复制成功');
      });
    },
    // 获取钱包余额
    async getBalance() {
      this.allBalance = 0
      let r = await getWalletInfoV2({
        user_id: this.user_id,
        role_id: this.role.role_id,
      });
      this.wallet_list = r.content.wallet_list;
      this.allBalance = 0;
      r.content.wallet_list.map((item) => {
        this.allBalance = this.allBalance + item.money;
      });
      this.allBalance = this.allBalance.toFixed(2);
    },
    // 4.登录红包 1.等级红包 2.充值红包 3.高级红包
    selectWithdrawType(walletItem) {
      this.withdrawType = walletItem.sub_rule_type;
      this.withdrawMethod = walletItem.wallet_type;
      this.availWithdrawAmount = walletItem.money;
      this.getWithdrawOptions();
      this.withdrawStep = 2;
    },
    handleWalletName(walletItem) {
      if (walletItem.wallet_type == 1 && walletItem.sub_rule_type == 5) {
        return '普通提现'
      } else if (walletItem.wallet_type == 2 && walletItem.sub_rule_type == 5) {
        return '闪电提现'
      } else if (walletItem.wallet_type == 1 &&walletItem.sub_rule_type == 1) {
        return '等级红包普通提现'
      } else if (walletItem.wallet_type == 1 &&walletItem.sub_rule_type == 2) {
        return '充值红包普通提现'
      } else if (walletItem.wallet_type == 1 &&walletItem.sub_rule_type == 3) {
        return '高级红包普通提现'
      } else if (walletItem.wallet_type == 1 &&walletItem.sub_rule_type == 4) {
        return '登录红包普通提现'
      } else if (walletItem.wallet_type == 2 &&walletItem.sub_rule_type == 1) {
        return '等级红包闪电提现'
      } else if (walletItem.wallet_type == 2 &&walletItem.sub_rule_type == 2) {
        return '充值红包闪电提现'
      } else if (walletItem.wallet_type == 2 &&walletItem.sub_rule_type == 3) {
        return '高级红包闪电提现'
      } else if (walletItem.wallet_type == 2 &&walletItem.sub_rule_type == 4) {
        return '登录红包闪电提现'
      }
    },
    setWithDrawStep(type, method) {
      this.withdrawType = type;
      this.withdrawMethod = method;
      this.withdrawStep = 2;
      this.getWithdrawOptions();
    },
    back() {
      if (this.withdrawStep != 0) {
        this.methodOptions = [];
        this.currentMethod = {};
        this.withDrawAccount = null;
        this.withdrawStep = 0;
        return;
      } 
      this.$emit('setPage', 'receive');
    },
    selectMoney(item) {
      const { value } = item;
      this.hintShow = Number(value) > Number(this.availWithdrawAmount);
      this.withDrawAccount = item;
      this.currentMethod = {};
      this.methodOptions = [];
      // 需要按照支付宝、微信、直充显示
      if (item.withdraw_type.includes(2)) {
        this.methodOptions.push({ label: '支付宝提现', value: RECHARGE_TYPE.ALIPAY, icon: `${this.$cdnLink}/common/zfb1.png` })
      }
      if (item.withdraw_type.includes(1)) {
        this.methodOptions.push({ label: '微信提现', value: RECHARGE_TYPE.WECHAT, icon: `${this.$cdnLink}/common/wx1.png` })
      }
      if (item.withdraw_type.includes(3)) {
        this.methodOptions.push({ label: '游戏直充', value: RECHARGE_TYPE.DIRECT, icon: `${this.$cdnLink}/common/direct.png` })
      }
    },
    selectMethods(item) {
      this.currentMethod = item;
    },
    toRecord() {
      this.$emit('setPage', 'record');
    },
    withDraw() {
      if (!this.withDrawAccount) {
        this.$toast('请选择提现金额');
        return;
      }
      if (!this.currentMethod.value) {
        this.$toast('请选择提现方式');
        return;
      }
      if (this.hintShow) {
        this.$toast('您的余额不足，无法提现');
        return;
      }
      if (this.withDrawAccount.money_threshold && Number(this.availWithdrawAmount) >= Number(this.withDrawAccount.value) && Number(this.availWithdrawAmount) < Number(this.withDrawAccount.money_threshold)) {
        this.$toast(`余额达到${this.withDrawAccount.money_threshold}元方可提现哦`);
        return;
      }
      if (this.withDrawAccount.count == 0) {
        this.$toast('无剩余可提现次数');
        return;
      }
      
      // 防止重复点击
      if (this.withDrawFlag) return;
      this.withDrawFlag = true;
      this.currentWithDrawType = this.currentMethod.value;
      this.commomWithdraw();
    },
    async commomWithdraw() {
      try {
        let r = await withDrawV2({
          user_id: this.user_id,
          role_id: this.role.role_id,
          sub_rule_type: this.withdrawType,
          wallet_type: this.withdrawMethod,
          money: this.withDrawAccount.value,
          type: this.currentMethod.value,
          server: this.role.server_num,
          role_name: this.role.role_name,
          server_name: this.role.server_name,
          appkey: this.appkey,
        });
        if (r.content.status == -1) {
          // 实名验证
          this.bindShow = true;
          this.withDrawFlag = false;
          return;
        }
        if (r.content.status == -2) {
          this.withDrawFlag = false;
          gameOpenDownloads({
            gameUrl: r.content.alipay_auth_uri,
          });
          return;
        }
        if (r.content.status == 4) {
          // 获取临时用户绑定码
          this.bindVisible = true;
          this.withDrawFlag = false;
          this.getAuthCode();
          return;
        }
        this.withDrawSuccess = true;
        this.getBalance();
        this.getWithdrawOptions();
        this.withDrawAccount = null;
        this.withdrawStep = 0;
        this.methodOptions = [];
        this.currentMethod = {};
      } catch (error) {}
      this.withDrawFlag = false;
    },
    async getWithdrawOptions() {
      let r = await getWithdrawOptionsV3({
          user_id: this.user_id,
          role_id: this.role.role_id,
          sub_rule_type: this.withdrawType,
          wallet_type: this.withdrawMethod
        });
      if (r.content.option_list && r.content.option_list.length) {
        this.options = r.content.option_list.map((item) => {
          return {
            ...item,
            label: `${item.money}元`,
            value: item.money
          };
        });
      } else {
        this.options = []
      }
    },
    jump() {
      gameOpenDownloads({
        gameUrl: this.receive_info.jump_link,
      });
    },
    toStep() {
      this.$emit('setPage', 'step');
    },
    handleWithDrawType() {
      if (this.currentWithDrawType == 1) {
        return '微信公众号'
      } else if (this.currentWithDrawType == 2) {
        return '支付宝'
      } else {
        return '游戏内'
      }
    },
    async getAuthCode() {
      const access_token = this.$getStorage('access_token');

      const r = await getTempId({
        user_id: this.user_id,
        access_token: access_token,
        appkey: this.appkey,
      });
      this.bindUserAuthCode = r.content.temp_id;
    },
    // 检查支付宝绑定接口
    async checkALiBind() {
      this.withDrawFlag = false;
      try {
        await checkALiBindResult({ user_id: this.user_id });
        this.$toast('绑定成功', 3000);
      } catch (error) {
        if (error.ret == 598 && this.retryTime < 5) {
          this.retryTime = this.retryTime + 1;
          setTimeout(this.checkALiBind, 2000);
        } else {
          this.$toast(error.msg, 3000);
        }
      }
    },
    activeJudge(item) {
      if (item.money_threshold) {
        return Number(this.availWithdrawAmount) >= Number(item.value) && Number(this.availWithdrawAmount) >= Number(item.money_threshold)
      } else if (item.type == 2) {
        return Number(this.availWithdrawAmount) >= Number(item.value) && item.count != 0
      } else {
        return Number(this.availWithdrawAmount) >= Number(item.value)
      }
    }
  },
  components: {
    AntiIndulged,
    Statement,
    Step
  },
};
</script>

<style lang="scss" module>
$font-lg: 15px;
$font-nm: 12px;
$font-sm: 9px;

.resetBtn {
  background-color: transparent;
  border: none;
  outline: none;
}
.btnActive {
  &:active {
    -webkit-filter: brightness(105%);
    filter: brightness(105%);
  }
}
.touchNone {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.wallet {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  background: #ffffff;
  border-radius: 10px;
  overflow: auto;
  padding: 6px;
  box-sizing: border-box;
  padding-bottom: 10px;
  &::-webkit-scrollbar {
    display: none;
  }
  > header {
    position: relative;
    font-size: $font-lg;
    color: #424242;
    text-align: center;
    margin-bottom: 6px;
    > .back {
      position: absolute;
      left: 0;
      font-size: $font-lg;
      box-sizing: content-box;
      padding: 5px {
        top: 0;
        left: 0;
      }
    }
  }
  .redEnvelopeType {
    .typeList {
      > li {
        height: 46px;
        background: #fafafa;
        border-radius: 2.5px;
        margin-bottom: 7px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 10px;
        > div {
          display: flex;
          align-items: center;
          > img {
            width: 36px;
            height: 36px;
            margin-right: 7px;
          }
          .typeName {
            font-size: 12px;
            font-weight: 700;
            margin-bottom: 5px;
          }
          .typeBalance {
            font-size: 8px;
            font-weight: 500;
            color: #959595;
            > span {
              color: #ff5b58;
            }
          }
        }
        > button {
          width: 60px;
          height: 22.5px;
          background: #ff5b58;
          border-radius: 11.5px;
          font-size: 8px;
          text-align: center;
          color: #ffffff;
          line-height: 22.5px;
          border: none;
          outline: none;
          &:active {
            opacity: 0.8;
          }
        }
      }
    }
  }
  .record {
    margin-top: 20px;
    text-align: right;
    color: #ff5b58;
    font-size: $font-nm;
    :global {
      .yw-xiangyou {
        font-size: 10px;
      }
    }
  }
  .selectMethods {
    .typeItem {
      padding: 0 10px;
      background: #fafafa;
      border-radius: 2.5px;
      height: 46px;
      display: flex;
      align-items: center;
      font-size: 12px;
      position: relative;
      margin: 5px auto;
      > img {
        width: 38px;
        height: 38px;
        margin-right: 6px;
      }
      .withdraw {
        position: absolute;
        right: 10px;
        margin: 0;
        width: 80px;
        height: 25px;
        font-size: 11px;
        line-height: 24.5px;
      }
      .balance {
        > p:nth-child(1) {
          font-size: 12px;
          font-weight: 700;
          margin-bottom: 5px;
        }
        > p:nth-child(2) {
          color: #959595;
          text-align: left;
          margin-top: 5px;
          font-size: 8px;
          > span {
            color: #ff362e;
          }
        }
      }
    }
  }
  .info {
    width: 100%;
    height: 76px;
    border-radius: 4px;
    background: url('//sdk-static.zhangyuqu.com/Lianyun/SdkImg/red-envelope/v2/wallet_back.png') no-repeat;
    background-size: 100% 100%;
    font-size: $font-nm;
    color: #ffffff;
    box-sizing: border-box;
    padding: {
      bottom: 19px;
      left: 22px;
      right: 32px;
    }
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding-top: 20px;
    margin-bottom: 17px;
    :global {
      .yw-xiangyou {
        font-size: $font-nm;
      }
    }
    .account {
      margin-bottom: 15px;
    }
  }
  .method,
  .price {
    > h3 {
      color: #000000;
      font-size: $font-nm;
      padding-left: 4px;
      margin-bottom: 6px;
    }
    .fr {
      float: right;
      margin-top: -10px;
      color: #FF5B58;
    }
  }
  .price {
    > h3 {
      margin-bottom: 12px;
    }
    > ul {
      width: 100%;
      > li {
        width: 59px;
        height: 38px;
        border-radius: 5px;
        background: #f7f7f7;
        font-size: 14px;
        text-align: center;
        line-height: 42px;
        color: #000000;
        position: relative;
        margin-bottom: 25px;
        display: inline-block;
        margin-right: 4px;
        .avail {
          display: none;
        }
        .amountHint {
          position: absolute;
          bottom: -15px;
          left: 0px;
          width: 59px;
          color: #959595;
          font-size: 8px;
          line-height: 10px;
        }
        .remain {
          position: absolute;
          bottom: -23px;
          left: 0px;
          width: 59px;
          color: #959595;
          font-size: 8px;
          line-height: 10px;
          > span {
            color: #ff5b58;
          }
        }
        &.active {
          background: #fff2ea;
          .avail {
            display: inline-block;
            position: absolute;
            top: 0;
            left: 0;
            border-top-left-radius: 4px;
            border-bottom-right-radius: 5px;
            background: #ff5b58;
            width: 32px;
            height: 13px;
            color: #FFFFFF;
            font-size: 8.5px;
            line-height: 13px;
            text-align: center;
          }
        }
        &.select {
          border: 1px solid #ff5b58;
        }
      }
    }
    .hint {
      display: none;
      color: #e85333;
      font-size: $font-sm;
      // display: inline-block;
      margin-left: 6px;
      &.active {
        display: inline-block;
      }
    }
  }
  .method {
    font-size: 0;
    > h3 {
      display: inline-block;
      margin-bottom: 0px;
    }
    .options {
      font-size: 12px;
      display: flex;
      > li {
        padding: 5px 14px 0px;
        border-radius: 4px;
        margin-right: 12px;
        margin-bottom: 4px;
        box-sizing: border-box;
        > p {
          font-weight: 600;
          text-align: center;
        }
        img {
          width: 40px;
          height: 40px;
          display: block;
          margin: auto {
            top: 2px;
          };
        }
        > div {
          width: 69px;
          height: 48px;
          border-radius: 4px;
          margin-bottom: 4px;
          border: 1px solid #FFFFFF;
          position: relative;
        }
        .recommend {
          position: absolute;
          top: 1px;
          right: 2px;
          width: 24px;
          height: 12px;
        }
        &.active {
          > div {
            background: #fff2ea;
            border: 1px solid #ff0000;
          }
        }
      }
    }
    > .hint {
      color: #e85333;
      font-size: $font-sm;
      margin-top: 6px;
      margin-left: 1px;
    }
  }
  .balanceWithdraw {
    padding: 10px;
  }
  .withdraw {
    @extend .resetBtn;
    @extend .btnActive;
    background: #ff5b58;
    color: #ffffff;
    display: block;
    width: 200px;
    height: 33.5px;
    line-height: 34px;
    font-size: 13px;
    border-radius: 33px;
    margin: auto {
      top: 10px;
    }
    &.submit {
      position: absolute;
      bottom: 30px;
      left: 50%;
      transform: translateX(-50%);
    }
  }
  .statement {
    position: absolute;
    bottom: 10px;
    right: 10px;
    display: flex;
    justify-content: space-between;
    > p {
      color: #ff5b58;
      font-size: 12px;
      margin-top: 10px;
      text-decoration: underline;
    }
  }
  .popup {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 100;
    .content {
      width: 278px;
      height: 186px;
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      margin: auto;
      background: url('//sdk-static.zhangyuqu.com/Lianyun/SdkImg/suspend/fuli/back.png');
      background-size: 100% 100%;
      font-size: 14px;
      text-align: left;
      padding: 40px 10px 0;
      box-sizing: border-box;
      .fanhui {
        position: absolute;
        top: 8px;
        right: 8px;
        color: #ffffff;
      }
      > p {
        line-height: 18px;
        > span {
          color: #ff5b58;
        }
      }
      > p:nth-child(1),
      > p:nth-child(2) {
        font-weight: 700;
        > span {
          font-weight: 700;
        }
      }
      .link {
        color: #1505fe;
        text-decoration: underline;
      }
      .sm {
        font-size: 12px;
      }
      .hint {
        margin-top: 15px;
      }
    }
    &.bindAccount {
      .content {
        width: 328px;
        height: 256px;
        padding: 20px 10px 0;
        > p:nth-child(1),
        > p:nth-child(2) {
          font-size: 16px;
          margin-bottom: 5px;
          font-weight: 700;
          > span {
            font-weight: 700;
          }
        }
      }
      .bindContent {
        display: flex;
        font-size: 14px;
        width: 100%;
        justify-content: center;
        align-items: center;
        margin-top: 10px;
        .code {
          width: 100px;
          white-space: nowrap; //禁止换行
          overflow: hidden;
          text-overflow: ellipsis;
          margin-right: 5px;
          overflow: hidden;
        }
        > button {
          @extend .resetBtn;
          @extend .btnActive;
          background: #ff5b58;
          font-size: 12px;
          padding: 4px 8px;
          color: #ffffff;
          display: block;
          border-radius: 4px;
          &:active {
            opacity: 0.8;
          }
        }
      }
      .redirectWechat {
        @extend .withdraw;
        margin-top: 15px;
        width: 160px;
        height: 28px;
        font-size: 12px;
        line-height: 27.5px;
      }
    }
  }
}
</style>
